import { ChangeDetectionStrategy, Component, computed, input } from "@angular/core";

import { MinimalSubscription } from "../../pages/subscription-detail/types";
import { FooterComponent } from "../common/footer/footer";
import { NavigationComponent } from "../common/navigation/navigation";

@Component({
  selector: "page",
  templateUrl: "page.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [FooterComponent, NavigationComponent],
})
export class PageComponent {
  protected subscription = input.required<MinimalSubscription | undefined>();
  protected reportedStatus = input("");

  private status = computed(() => (this.reportedStatus() !== "" ? this.reportedStatus() : this.subscription()?.status));
  private title = computed(() => this.subscription()?.customerDescription || "");

  protected detailData = computed(() => ({ title: this.title(), status: this.status() ?? "" }));
  protected firewalled = computed(() => this.subscription()?.firewallEnabled ?? false);
  protected productType = computed(() => this.subscription()?.product.type ?? "");
  protected terminated = computed(() => this.status() === "terminated");
}
